export enum PageType {
  mixed = 'mixedContent',
  single = 'singleContent',
}
